import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let ourTeamSwiperWr = document.querySelectorAll('.our-team-swiper-wr');


console.log('sadas1')
ourTeamSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 18,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: { 
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        375: {
          slidesPerView: 1,
          spaceBetween: 24,
        },
        500: {
          // slidesPerView: 1.5,
          spaceBetween: 24,
        },
        768: {
          // slidesPerView: 2,
          spaceBetween: 24,
        },
        992: {
          // slidesPerView: 2.2,
          spaceBetween: 32,
        },
        1200: {
          // slidesPerView: 3,
          spaceBetween: 48,
        }
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
    });
    swiperObserver(swiper);
  }
});
